import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 18H8V16H20V18ZM6 18H4V16H6V18ZM20 13H8V11H20V13ZM6 13H4V11H6V13ZM20 8H8.023V6H20V8ZM6 8H4V6H6V8Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ListUl"
);
